const SEDE_KEY = "sedeSeleccionada";
const NAC_KEY = "fechaNacimiento";
const HORARIO_KEY = "horarioStorage";

const setFechaNacimiento = (fecha) => {
  window.localStorage.setItem(NAC_KEY, JSON.stringify(fecha));
};

const getFechaNacimiento = () => {
  return JSON.parse(window.localStorage.getItem(NAC_KEY));
};

const eliminarFechaNacimiento = () => {
  window.localStorage.removeItem(NAC_KEY);
};
const setSedeSeleccionada = (sede) => {
  window.localStorage.setItem(SEDE_KEY, JSON.stringify(sede));
};

const getSedeSeleccionada = () => {
  return JSON.parse(window.localStorage.getItem(SEDE_KEY));
};

const eliminarSedeSeleccionada = () => {
  window.localStorage.removeItem(SEDE_KEY);
};
const setMapHorarioStorage = (arrayHorarios) => {
  window.localStorage.setItem(HORARIO_KEY, JSON.stringify(arrayHorarios));
};

const getMapHorarioStorage = () => {
  return JSON.parse(window.localStorage.getItem(HORARIO_KEY));
};

const eliminarMapHorarioStorage= () => {
  window.localStorage.removeItem(HORARIO_KEY);
};

export { setSedeSeleccionada, getSedeSeleccionada, eliminarSedeSeleccionada, 
  setFechaNacimiento,getFechaNacimiento, eliminarFechaNacimiento,
  setMapHorarioStorage,getMapHorarioStorage,eliminarMapHorarioStorage  };
